import { render } from "./Felom.vue?vue&type=template&id=cdfd70b6&scoped=true"
import script from "./Felom.vue?vue&type=script&lang=js"
export * from "./Felom.vue?vue&type=script&lang=js"

import "./Felom.vue?vue&type=style&index=0&id=cdfd70b6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cdfd70b6"

export default script